// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 0.856049L21 6.41161V9.00001H1V6.41161L11 0.856049ZM6 11V19H4V11H6ZM12 11V19H10V11H12ZM18 11V17H16V11H18ZM22.5961 17.9394L16.9392 23.5963L13.4037 20.0608L14.8179 18.6466L16.9392 20.7679L21.1819 16.5252L22.5961 17.9394ZM1 21H12V23H1V21Z"}}]};

const InstitutionCheckedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'institution-checked-filled',
    ref,
    icon: element,
  },
));

InstitutionCheckedFilledIcon.displayName = 'InstitutionCheckedFilledIcon';

export default InstitutionCheckedFilledIcon;
